import { render, staticRenderFns } from "./CompensationYear.vue?vue&type=template&id=57de128c&scoped=true"
import script from "./CompensationYear.vue?vue&type=script&lang=js"
export * from "./CompensationYear.vue?vue&type=script&lang=js"
import style0 from "./CompensationYear.vue?vue&type=style&index=0&id=57de128c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de128c",
  null
  
)

export default component.exports